import { useState } from "react";

export const usePaymentMethods = () => {
  const [openPayment, setOpenPayment] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState<"card" | "cash" | "later" | null>(null);

  const selectMethod = (method: "card" | "cash" | "later") => {
    setSelectedMethod(method);
    setOpenPayment(true);
  };

  const resetPayment = () => {
    setSelectedMethod(null);
    setOpenPayment(false);
  };

  return {
    openPayment,
    selectedMethod,
    selectMethod,
    resetPayment,
  };
};
